module.exports = __webpack_public_path__ + "img/FR12869.ddd01e77.svg";